import usePrefix from './use-prefix'
import { isObservable } from 'mobx'

function splitName (name) {
  if (typeof (name) !== 'string') {
    return []
  }
  return name.split(/[\[\]\.]/).filter(part => part !== '')
}

function getPrefixFor (context) {
  const prefix = usePrefix()

  if (typeof (prefix) === 'undefined' || prefix === null) {
    return null
  }

  if (isObservable(prefix)) {
    return prefix.get(context)
  }

  if (typeof prefix === 'object' && prefix[context]) {
    return prefix[context]
  }

  if (typeof prefix === 'string') {
    return prefix
  }

  return null
}

export default function useName (baseName = null, { type } = {}) {
  if (!type) {
    type = 'name'
  }

  const parts = []

  let prefix = getPrefixFor(type)

  if (prefix !== null && typeof prefix !== 'undefined') {
    if (typeof (prefix) === 'object') {
      prefix = ''
    }

    if (typeof (prefix) !== 'string') {
      prefix = prefix + ''
    }

    if (prefix !== '') {
      parts.push(...splitName(prefix))
    }
  }

  if (typeof baseName === 'string') {
    parts.push(...splitName(baseName))
  }

  return parts.join('.')
}
